/* eslint-disable no-restricted-globals */
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Typography, Grid, Paper, Box } from "@mui/material";
import axios from "axios";
import { Helmet } from "react-helmet";
import Styles from "./styles";
import Logo from "../../assets/images/BSG-logo.png";
import ForgotScreenBG from "../../assets/images/LoginBackground.png";
import Button from "../../components/Layout/Button/NewButton";
import { AlertStatus } from "../../contants";
import { ROUTES } from "../../components/Routes";
import InputField from "../../components/Layout/fieldInput/InputField";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";

const endPoint = process.env.REACT_APP_API_BASE_URL;

const CommonStyles = {
  buttonStyle: {
    marginTop: "20px",
  },
};

function Forgot() {
  const [memberId, setMemberId] = useState("");
  const toast = useContext(ToastAlertContext);
  const [isNumber, setIsNumber] = useState(true);
  const navigate = useNavigate();
  const TITLE = "Forget Password - BSG ContributionAdmin";

  const handleChange = (e) => {
    const { value } = e.target;
    setMemberId(value);
    setIsNumber(!isNaN(value));
  };

  const validation = () => {
    if (!memberId) {
      return "Please enter Member ID";
    }
    if (!isNumber) {
      return "Please enter a valid Member ID";
    }
    return "";
  };

  // eslint-disable-next-line consistent-return
  const postData = async () => {
    try {
      const error = validation();
      if (error) throw new Error(error);
      const data = { memberId };

      const response = await axios.post(`${endPoint}/resetPassword`, {
        ...data,
      });
      toast.show(
        "OTP sent to your registered email successfully",
        AlertStatus.SUCCESS,
      );
      const authToken = response.headers["x-auth-token"];
      setTimeout(() => {
        navigate(`${ROUTES.CHANGE_PASSWORD}/${memberId}/${authToken}`);
      }, 2000);
    } catch (error) {
      if (error.response) {
        toast.show(error.response.data.message, AlertStatus.ERROR);
      } else {
        toast.show(
          error.message || "Please contact support. Something went wrong",
          AlertStatus.ERROR,
        );
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: `url(${ForgotScreenBG})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Grid
          style={{
            height: 100,
            display: "flex",
            marginLeft: "14%",
            padding: 20,
          }}
        >
          <img src={Logo} alt="logo" />
        </Grid>
        <Grid
          style={{
            padding: "15px 45px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "calc(100vh - 100px)",
          }}
        >
          <Paper elevation={1} style={Styles.paperStyle}>
            <form /* onSubmit={handleSubmit} */>
              <div style={Styles.divContainer}>
                <Typography style={Styles.typographyHeading}>
                  Reset Password
                </Typography>
                <Typography style={Styles.typographyMessage}>
                  Enter your Member ID and we will send you instructions to
                  reset your password.
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <InputField
                    label="Member ID"
                    Placeholder="Member ID"
                    required
                    name="memberId"
                    type="text"
                    value={memberId}
                    onChange={handleChange}
                    style={Styles.fieldStyle}
                  />
                  <Button
                    variant="contained"
                    style={{
                      ...Styles.buttonStyle,
                      ...CommonStyles.buttonStyle,
                    }}
                    // isLoading={isLoading}
                    label="Reset Password"
                    onClick={() => {
                      postData();
                    }}
                  >
                    {" "}
                  </Button>
                </Box>
                <Box>
                  <Typography style={Styles.typographyFooter}>
                    <Link to="/" style={Styles.typographyFooter}>
                      Return to Login
                    </Link>
                  </Typography>
                </Box>
              </div>
            </form>
          </Paper>
        </Grid>
      </Box>
    </>
  );
}

export default Forgot;
